// ============================================================
// Teslim imzası — dokunmatik imza alanı (§4)
//
// Cihaz tablet: öğretmen bahçede ya da kapıda parmakla imza alıyor.
// Bu yüzden pointer olayları kullanılıyor (fare, dokunma ve kalem
// aynı kodla), ve çizim sırasında sayfanın kaydırılmaması için
// touch-action kapatılıyor — aksi hâlde parmak çizmek yerine
// sayfayı kaydırıyor.
//
// Canvas cihazın piksel yoğunluğuna göre ölçekleniyor; aksi hâlde
// retina tablette imza bulanık çıkıyor.
// ============================================================

const CIZGI = "#2B2440";

export const imzaAlaniMarkup = () => `
  <div class="mt-4">
    <div class="flex items-center justify-between mb-1.5">
      <span class="text-[11px] font-bold text-inksoft uppercase tracking-wider">Teslim alan kişinin imzası</span>
      <button type="button" data-imza-temizle
        class="text-[11px] font-semibold text-inksoft hover:text-ink underline">Temizle</button>
    </div>
    <canvas data-imza
      class="w-full h-32 rounded-xl border-2 border-dashed border-line bg-white touch-none"></canvas>
    <p data-imza-ipucu class="text-[11px] text-inksoft mt-1">
      Parmakla veya kalemle imzalayın. İmza zorunlu değildir; alınmazsa
      çıkış yine kaydedilir ve denetim izine "imzasız" yazılır.
    </p>
  </div>`;

/**
 * İmza alanını canlandırır.
 * @returns {{bos: () => boolean, veri: () => string|null, temizle: () => void}}
 */
export function imzaAlaniniBagla(kok, degisti) {
  const canvas = kok.querySelector("[data-imza]");
  if (!canvas) return { bos: () => true, veri: () => null, temizle: () => {} };

  const ctx = canvas.getContext("2d");
  let cizildi = false;
  let basili = false;

  // Görünen boyut CSS'ten geliyor; bitmap'i cihaz oranıyla kuruyoruz.
  const olcekle = () => {
    const oran = window.devicePixelRatio || 1;
    const kutu = canvas.getBoundingClientRect();
    if (!kutu.width) return;
    canvas.width = Math.round(kutu.width * oran);
    canvas.height = Math.round(kutu.height * oran);
    ctx.scale(oran, oran);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = CIZGI;
  };
  olcekle();

  const nokta = (e) => {
    const k = canvas.getBoundingClientRect();
    return { x: e.clientX - k.left, y: e.clientY - k.top };
  };

  canvas.addEventListener("pointerdown", (e) => {
    basili = true;
    canvas.setPointerCapture(e.pointerId);
    const p = nokta(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    // Tek dokunuş da bir iz bırakmalı — nokta imza da imzadır.
    ctx.lineTo(p.x + 0.01, p.y);
    ctx.stroke();
    cizildi = true;
    degisti?.();
  });

  canvas.addEventListener("pointermove", (e) => {
    if (!basili) return;
    const p = nokta(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  });

  const birak = (e) => {
    if (!basili) return;
    basili = false;
    try { canvas.releasePointerCapture(e.pointerId); } catch { /* zaten bırakılmış */ }
  };
  canvas.addEventListener("pointerup", birak);
  canvas.addEventListener("pointercancel", birak);
  canvas.addEventListener("pointerleave", birak);

  const temizle = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    cizildi = false;
    degisti?.();
  };
  kok.querySelector("[data-imza-temizle]")?.addEventListener("click", temizle);

  return {
    bos: () => !cizildi,
    // PNG: imza çizgi grafiği, JPEG'in bulanıklaştırdığı türden.
    veri: () => (cizildi ? canvas.toDataURL("image/png") : null),
    temizle,
  };
}
